// Job 10: every client entered into Bill Validation is a Shield Platinum client,
// so the flag is applied automatically rather than ticked by hand.
//
// The flag lived in two places: `client.shield_platinum` (the real column, written
// by Tenders) and `client.extn.bv.shield_platinum` (written by the BV forms). BV
// read only the second, so a client shielded in Tenders showed "—" in the BV list
// while exports — which read the column first — disagreed with both.
//
// The real column is now the single source of truth and the BV writers set it.
// extn stays readable so clients flagged before migration 069 runs, or on an
// environment where it hasn't been applied, don't read as "No".

import type { BvOrganisation } from '../types/billValidationTypes';

export const isClientShielded = (
  org: Pick<BvOrganisation, 'shield_platinum' | 'extn'> | null | undefined,
): boolean => !!(org?.shield_platinum || org?.extn?.bv?.shield_platinum);
